import { ButtonNew as Button } from "components/buttonNew";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import "./loyalty.scss";


export default function GetStarted() {
    const {t} = useTranslation();
    const history = useHistory();

    return (
        <div className="loyalty-get-started">
            <div className="loyalty-get-started-group">
                <p className="loyalty-get-started-title">{t("Boost Repeat Play with a Loyalty Program")}</p>
                <p className="loyalty-get-started-secondary">{t("Engage golfers with points, perks, and rewards they'll return for.")}</p>
                <div className="loyalty-get-started-cards-container">
                    <div className="loyalty-get-started-card">
                        <p className="loyalty-get-started-primary">{t("Turn sales into points")}</p>
                        <p className="loyalty-get-started-secondary">{t("Golfers earn points on every booking and purchase.")}</p>
                    </div>
                    <div className="loyalty-get-started-card">
                        <p className="loyalty-get-started-primary">{t("Build customer loyalty")}</p>
                        <p className="loyalty-get-started-secondary">{t("See who plays most and reward your top golfers.")}</p>
                    </div>
                    <div className="loyalty-get-started-card">
                        <p className="loyalty-get-started-primary">{t("Boost repeat revenue")}</p>
                        <p className="loyalty-get-started-secondary">{t("Perks keep players coming back—and spending more.")}</p>
                    </div>
                </div>
                <div className="ml-auto mr-auto">
                <Button type="primary" size="medium" onClick={() => history.push("/admin/settings/loyalty-program/step-1")}>{t("Get Started")}</Button>
                </div>
            </div>
        </div>
    );
}